import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import DevBanner from './components/DevBanner';
import Home from './pages/Home';
import Actualites from './pages/Actualites';
import PermanenceNumerique from './pages/PermanenceNumerique';
import Benevole from './pages/Benevole';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import AdminPermanences from './pages/AdminPermanences';
import AdminActualites from './pages/AdminActualites';
import NotFound from './pages/NotFound';
import Footer from './components/Footer';
import CookieConsent from './components/CookieConsent';
import PolitiqueConfidentialite from './pages/PolitiqueConfidentialite';
import Contact from './pages/Contact';
import MentionsLegales from './pages/MentionsLegales';
import AdminRegister from './pages/AdminRegister';
import ProtectedRoute from './components/ProtectedRoute';

function Layout() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');

  return (
    <>
      {!isAdminRoute && <Header />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/actualites" element={<Actualites />} />
        <Route path="/permanence-numerique" element={<PermanenceNumerique />} />
        <Route path="/benevole" element={<Benevole />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
        <Route path="/mentions-legales" element={<MentionsLegales />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
        <Route path="/admin/permanences" element={<ProtectedRoute><AdminPermanences /></ProtectedRoute>} />
        <Route path="/admin/actualites" element={<ProtectedRoute><AdminActualites /></ProtectedRoute>} />
        <Route path="/admin/register" element={<ProtectedRoute><AdminRegister /></ProtectedRoute>} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      {!isAdminRoute && <Footer />}
      {!isAdminRoute && <CookieConsent />}
    </>
  );
}

function App() {
  useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      document.body.classList.add('dev-mode');
    }
    return () => document.body.classList.remove('dev-mode');
  }, []);

  return (
    <Router>
      <DevBanner />
      <Layout />
    </Router>
  );
}

export default App;